// ============================================================
// Hälsohjulet – Quiz JavaScript
// Egenvårdsbutiken, Shrine-temat
// Inga svar, poäng eller resultat sparas.
// Allt sker i webbläsaren.
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  var section = document.getElementById('halsohijulet');
  if (!section) return;

  // ----------------------------------------------------------
  // FRÅGOR
  // ----------------------------------------------------------
  var QUESTIONS = [
    { area: 'body',   text: 'Jag äter regelbundet och på ett sätt som ger mig stabil energi under dagen.' },
    { area: 'body',   text: 'Jag får i mig tillräckligt med näringsrik mat, exempelvis grönsaker, frukt/bär, fullkorn, baljväxter eller andra fiberrika livsmedel.' },
    { area: 'body',   text: 'Jag får i mig protein regelbundet under dagen.' },
    { area: 'body',   text: 'Jag rör på kroppen på ett sätt som passar min kropp och min vardag.' },
    { area: 'body',   text: 'Jag får in både vardagsrörelse och någon form av fysisk träning eller aktivitet.' },
    { area: 'body',   text: 'Jag sover vanligtvis tillräckligt för att känna mig relativt återhämtad.' },
    { area: 'body',   text: 'Jag har oftast regelbundna sömn- och uppstigningstider.' },
    { area: 'body',   text: 'Jag ger min kropp tillräckligt med återhämtning mellan perioder av aktivitet och belastning.' },
    { area: 'body',   text: 'Jag lyssnar på kroppens signaler och reagerar när jag behöver vila, äta, dricka eller röra på mig.' },
    { area: 'body',   text: 'Jag känner mig i huvudsak stark, rörlig och kapabel i min kropp.' },
    { area: 'mind',   text: 'Jag kan lägga märke till mina tankar utan att automatiskt tro på allt jag tänker.' },
    { area: 'mind',   text: 'Jag kan förhålla mig relativt konstruktivt till mina misstag och motgångar.' },
    { area: 'mind',   text: 'Jag ställer rimliga krav på mig själv.' },
    { area: 'mind',   text: 'Jag kan säga nej till sådant som tar mer energi än jag har möjlighet att ge.' },
    { area: 'mind',   text: 'Jag kan fokusera på det jag faktiskt kan påverka.' },
    { area: 'mind',   text: 'Jag fastnar sällan länge i oro, ältande eller negativa tankespiraler.' },
    { area: 'mind',   text: 'Jag ger min hjärna regelbundna pauser från information, skärmar och krav.' },
    { area: 'mind',   text: 'Jag kan vara närvarande i det jag gör utan att ständigt tänka på nästa sak.' },
    { area: 'mind',   text: 'Jag känner i grunden att jag duger även när jag inte presterar på topp.' },
    { area: 'mind',   text: 'Jag har strategier som hjälper mig när livet känns mentalt utmanande.' },
    { area: 'heart',  text: 'Jag har minst en person som jag kan vara genuin med och prata öppet med.' },
    { area: 'heart',  text: 'Jag känner mig sedd och uppskattad av människor i min närhet.' },
    { area: 'heart',  text: 'Jag kan ta emot omsorg och hjälp utan att känna mig som en börda.' },
    { area: 'heart',  text: 'Jag tillåter mig att känna det jag känner, utan att genast trycka ned eller döma mina känslor.' },
    { area: 'heart',  text: 'Jag kan sätta gränser i relationer utan att känna överväldigande skuld.' },
    { area: 'heart',  text: 'Jag har utrymme i mitt liv för relationer som ger mig energi.' },
    { area: 'heart',  text: 'Jag kan hantera konflikter eller svåra samtal utan att det tar över helt.' },
    { area: 'heart',  text: 'Jag känner mig inte kroniskt ensam eller isolerad.' },
    { area: 'heart',  text: 'Jag har tillgång till glädje, lek eller lätthet i vardagen.' },
    { area: 'heart',  text: 'Jag behandlar mig själv med ungefär samma omsorg som jag skulle visa en god vän.' },
    { area: 'spirit', text: 'Jag känner att mitt liv innehåller sådant som känns meningsfullt för mig.' },
    { area: 'spirit', text: 'Jag vet i stora drag vad som är viktigt för mig i livet.' },
    { area: 'spirit', text: 'Min vardag innehåller saker som ger mig glädje eller energi utan att de behöver vara produktiva.' },
    { area: 'spirit', text: 'Jag har kontakt med naturen på något sätt som får mig att må bra.' },
    { area: 'spirit', text: 'Jag har utrymme för kreativitet, musik, dans, skapande eller något annat som får mig att känna mig levande.' },
    { area: 'spirit', text: 'Jag har något att se fram emot.' },
    { area: 'spirit', text: 'Jag känner att det jag gör i vardagen hänger ihop med mina värderingar.' },
    { area: 'spirit', text: 'Jag kan ibland stanna upp och känna tacksamhet, förundran eller närvaro.' },
    { area: 'spirit', text: 'Jag känner att livet har ett sammanhang även när allt inte går som jag vill.' },
    { area: 'spirit', text: 'Jag upplever att jag utvecklas eller växer som människa på något sätt.' }
  ];

  var SCALE = [
    { value: 1, label: 'Stämmer inte alls' },
    { value: 2, label: 'Stämmer lite' },
    { value: 3, label: 'Stämmer delvis' },
    { value: 4, label: 'Stämmer ganska bra' },
    { value: 5, label: 'Stämmer helt' }
  ];

  var AREAS = ['body', 'mind', 'heart', 'spirit'];

  var AREA_NAMES = { body: 'Kropp', mind: 'Tanke', heart: 'Känsla', spirit: 'Ande' };

  var RESULT_PRIMARY = {
    body: {
      heading: '🌿 Ditt fokus just nu: Kropp',
      text: 'Dina svar pekar på att kropp och återhämtning kan vara ett område som är värt att ge lite extra utrymme just nu. Det behöver inte handla om stora förändringar – ofta är det de små, regelbundna sakerna som gör störst skillnad över tid. Kroppen är grunden för allt annat. Inte för att du måste prestera – utan för att du förtjänar att känna dig bra inifrån.',
      tips: [
        { icon: '🛏', title: 'Prioritera sömnen.', text: 'Sömn är en viktig grund för återhämtning och energi. Välj en tid att lägga dig och en tid att stiga upp – och försök hålla dem även på helgen i en vecka.' },
        { icon: '🚶', title: 'Rör på dig på dina villkor.', text: 'Det behöver inte vara träning. En promenad, att sträcka på sig, att dansa i köket – allt räknas. Hitta det som känns roligt, inte det som känns rätt.' },
        { icon: '🥗', title: 'Ät något som ger dig energi vid varje måltid.', text: 'Inte perfekt – bara lite mer medvetet. Vad gör att du känner dig mätt och nöjd, snarare än trött efteråt?' }
      ]
    },
    mind: {
      heading: '🌿 Ditt fokus just nu: Tanke',
      text: 'Dina svar pekar på att ditt inre samtal och dina tankemönster kan vara ett område som är värt lite extra omsorg just nu. Att ta hand om sina tankar handlar inte om att alltid tänka positivt. Det handlar om att skapa lite mer utrymme mellan dig och det du tänker – så att du kan välja hur du vill reagera.',
      tips: [
        { icon: '✍️', title: 'Skriv ned tre saker varje kväll.', text: 'Inte nödvändigtvis bra saker – bara tre saker som hände. Det hjälper hjärnan att landa och skapar distans till tankarna.' },
        { icon: '📵', title: 'Ge hjärnan en paus varje dag.', text: 'Välj en stund – kanske morgonen, kanske lunchen – utan skärm, utan podcast, utan input. Bara du och det du ser framför dig.' },
        { icon: '💬', title: 'Prata med dig själv som du skulle prata med en vän.', text: 'Nästa gång du tänker något hårt om dig själv – fråga: skulle jag säga det här till någon jag bryr mig om? Om inte, försök omformulera det.' }
      ]
    },
    heart: {
      heading: '🌿 Ditt fokus just nu: Känsla',
      text: 'Dina svar pekar på att relationer, gemenskap och utrymme för dina egna känslor kan vara ett område att ge lite extra omsorg just nu. Känslolivet är inte en svaghet. Det är det som gör dig mänsklig. Och att ta hand om det är en av de djupaste formerna av egenvård.',
      tips: [
        { icon: '📞', title: 'Ta kontakt med någon du saknar.', text: 'Inte för att det ska vara stort – ett meddelande, ett samtal, en fika. Välj en person och ta det första steget den här veckan.' },
        { icon: '🌿', title: 'Ge dig själv tillåtelse att känna.', text: 'Nästa gång en känsla dyker upp – försök inte genast lösa den eller trycka ned den. Stanna kvar i den i en minut. Vad vill den berätta?' },
        { icon: '🛑', title: 'Öva på att säga nej till en sak.', text: 'Välj något litet som du egentligen inte vill göra – och säg nej. Gränser är inte egoism. De är en förutsättning för äkta närvaro.' }
      ]
    },
    spirit: {
      heading: '🌿 Ditt fokus just nu: Ande',
      text: 'Dina svar pekar på att mening, riktning och sådant som verkligen engagerar dig kan vara ett område att ge lite mer utrymme just nu. Din inre kompass är värd att lyssna på. Och det börjar inte med stora beslut – det börjar med att märka vad som faktiskt rör något i dig.',
      tips: [
        { icon: '🌳', title: 'Gå ut i naturen utan ett mål.', text: 'Inte för att träna, inte för att hinna något. Bara för att vara ute. Lägg märke till något litet – ett ljud, en doft, hur ljuset faller.' },
        { icon: '🎨', title: 'Gör något du älskade som barn.', text: 'Rita, sjung, bygg, baka, läs, dansa – välj något som inte behöver vara nyttigt eller bra. Bara roligt.' },
        { icon: '📖', title: 'Skriv ned en sak som faktiskt känns meningsfull för dig.', text: 'Inte vad du borde tycka är meningsfullt – vad som faktiskt rör något i dig. Det är din kompass.' }
      ]
    }
  };

  var RESULT_SECONDARY = {
    body:   'Kropp och återhämtning är ett område som kan stärkas med små, regelbundna vanor. Lite mer sömn, rörelse eller mer medvetna matvanor kan göra stor skillnad över tid.',
    mind:   'Ditt tankemönster är ett område som kan stärkas med enkla, dagliga vanor. Lite mer självmedkänsla och lite färre krav på dig själv kan förändra mycket.',
    heart:  'Relationer och känslovärld är ett område som förtjänar mer utrymme. Börja litet – en kontakt, en gräns, en stund av äkthet.',
    spirit: 'Din känsla av mening och riktning kan stärkas med små, äkta stunder i vardagen. Det behöver inte vara stort för att vara viktigt.'
  };

  var LEVEL_DATA = [
    { min: 10, max: 24, symbol: '🌱', text: 'Här finns utrymme att stärka' },
    { min: 25, max: 34, symbol: '🌿', text: 'Kan stärkas' },
    { min: 35, max: 43, symbol: '🌳', text: 'Relativt välbalanserat' },
    { min: 44, max: 50, symbol: '✨', text: 'Stark grund' }
  ];

  // ----------------------------------------------------------
  // STATE
  // ----------------------------------------------------------
  var current = 0;
  var answers = new Array(40).fill(null);
  var selfFocus = null;
  var desiredOutcome = null;

  // ----------------------------------------------------------
  // DOM-REFERENSER
  // ----------------------------------------------------------
  var intro         = document.getElementById('hq-intro');
  var quizWrap      = document.getElementById('hq-quiz');
  var extraWrap     = document.getElementById('hq-extra');
  var resultWrap    = document.getElementById('hq-result');
  var questionWrap  = document.getElementById('hq-question-wrap');
  var progressBar   = document.getElementById('hq-progress-bar');
  var progressLabel = document.getElementById('hq-progress-label');
  var btnStart      = document.getElementById('hq-btn-start');
  var btnPrev       = document.getElementById('hq-btn-prev');
  var btnNext       = document.getElementById('hq-btn-next');
  var btnRestart    = document.getElementById('hq-btn-restart');
  var extra1        = document.getElementById('hq-extra-1');
  var extra2        = document.getElementById('hq-extra-2');

  // ----------------------------------------------------------
  // HJÄLPFUNKTIONER
  // ----------------------------------------------------------
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function calcScores() {
    var scores = { body: 0, mind: 0, heart: 0, spirit: 0 };
    QUESTIONS.forEach(function (q, i) {
      scores[q.area] += (answers[i] || 0);
    });
    return scores;
  }

  function getPrimarySecondary(scores) {
    var sorted = AREAS.slice().sort(function (a, b) {
      if (scores[a] !== scores[b]) return scores[a] - scores[b];
      return AREAS.indexOf(a) - AREAS.indexOf(b);
    });
    return { primary: sorted[0], secondary: sorted[1] };
  }

  function getLevel(score) {
    return LEVEL_DATA.find(function (l) { return score >= l.min && score <= l.max; }) || LEVEL_DATA[0];
  }

  function updateProgress() {
    var pct = Math.round((current / QUESTIONS.length) * 100);
    if (progressBar) progressBar.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = 'Fråga ' + (current + 1) + ' av ' + QUESTIONS.length;
  }

  function updateWheel(scores) {
    AREAS.forEach(function (area) {
      var el = document.getElementById('hq-wheel-' + area);
      if (!el) return;
      var level = getLevel(scores[area]);
      el.setAttribute('data-level', level.symbol);
      el.textContent = AREA_NAMES[area] + ': ' + scores[area] + ' – ' + level.text;
    });
  }

  // ----------------------------------------------------------
  // RENDERA FRÅGA
  // ----------------------------------------------------------
  function renderQuestion(index) {
    var q = QUESTIONS[index];
    var selected = answers[index];
    var html = '<div class="hq-area-label hq-area-' + q.area + '">' + AREA_NAMES[q.area] + '</div>';
    html += '<p class="hq-question-text">' + (index + 1) + '. ' + q.text + '</p>';
    html += '<div class="hq-scale" role="radiogroup">';
    SCALE.forEach(function (s) {
      var checked = selected === s.value ? 'checked' : '';
      var sel = selected === s.value ? ' hq-selected' : '';
      html += '<label class="hq-scale-option' + sel + '">';
      html += '<input type="radio" name="hq-answer" value="' + s.value + '" ' + checked + '>';
      html += '<span class="hq-scale-value">' + s.value + '</span>';
      html += '<span class="hq-scale-label">' + s.label + '</span>';
      html += '</label>';
    });
    html += '</div>';
    questionWrap.innerHTML = html;

    questionWrap.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        answers[index] = parseInt(radio.value, 10);
        questionWrap.querySelectorAll('.hq-scale-option').forEach(function (l) {
          l.classList.remove('hq-selected');
        });
        radio.closest('.hq-scale-option').classList.add('hq-selected');
        if (btnNext) btnNext.disabled = false;
      });
    });

    if (btnNext) btnNext.disabled = (selected === null);
    if (btnPrev) btnPrev.hidden = (index === 0);
    updateProgress();
  }

  // ----------------------------------------------------------
  // NAVIGATION
  // ----------------------------------------------------------
  function startQuiz() {
    current = 0;
    answers = new Array(40).fill(null);
    selfFocus = null;
    desiredOutcome = null;
    hide(intro);
    show(quizWrap);
    renderQuestion(0);
  }

  function next() {
    if (current < QUESTIONS.length - 1) {
      current++;
      renderQuestion(current);
    } else {
      showExtra();
    }
  }

  function prev() {
    if (current > 0) {
      current--;
      renderQuestion(current);
    }
  }

  // ----------------------------------------------------------
  // EXTRA FRÅGOR
  // ----------------------------------------------------------
  function showExtra() {
    hide(quizWrap);
    show(extraWrap);
    show(extra1);
    hide(extra2);

    extra1.querySelectorAll('.hq-extra-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selfFocus = btn.dataset.value;
        hide(extra1);
        show(extra2);
      });
    });

    extra2.querySelectorAll('.hq-extra-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        desiredOutcome = btn.dataset.value;
        hide(extraWrap);
        showResult();
      });
    });
  }

  // ----------------------------------------------------------
  // VISA RESULTAT
  // ----------------------------------------------------------
  function showResult() {
    var scores = calcScores();
    var ps = getPrimarySecondary(scores);
    var pData = RESULT_PRIMARY[ps.primary];
    var secText = RESULT_SECONDARY[ps.secondary];

    var tips = '';
    pData.tips.forEach(function (t) {
      tips += '<div class="hq-tip">';
      tips += '<span class="hq-tip-icon">' + t.icon + '</span>';
      tips += '<div><strong>' + t.title + '</strong><p>' + t.text + '</p></div>';
      tips += '</div>';
    });

    var primaryEl = document.getElementById('hq-result-primary');
    if (primaryEl) {
      primaryEl.innerHTML =
        '<h2 class="hq-result-heading">' + pData.heading + '</h2>' +
        '<p class="hq-result-text">' + pData.text + '</p>' +
        '<div class="hq-tips">' + tips + '</div>';
    }

    var secondaryEl = document.getElementById('hq-result-secondary');
    if (secondaryEl) {
      secondaryEl.innerHTML =
        '<h2 class="hq-result-heading">Ditt nästa område: ' + AREA_NAMES[ps.secondary] + '</h2>' +
        '<p class="hq-result-text">' + secText + '</p>';
    }

    updateWheel(scores);

    hide(quizWrap);
    hide(intro);
    show(resultWrap);
  }

  // ----------------------------------------------------------
  // EVENT LISTENERS – KNAPPAR
  // ----------------------------------------------------------
  if (btnStart)   btnStart.addEventListener('click',   function () { startQuiz(); });
  if (btnNext)    btnNext.addEventListener('click',    function () { next(); });
  if (btnPrev)    btnPrev.addEventListener('click',    function () { prev(); });
  if (btnRestart) btnRestart.addEventListener('click', function () {
    current = 0;
    answers = new Array(40).fill(null);
    selfFocus = null;
    desiredOutcome = null;
    hide(quizWrap);
    hide(resultWrap);
    show(intro);
  });

});

